module.exports = __webpack_public_path__ + "static/img/3.6b0795e0.png";